'use strict';

var ruleValidator = function () {
    var pswd = $(this).val();
    //gets what is being input in the field and sets as variable
    if (pswd.length < 8) {
        $('#length').removeClass('valid').addClass('invalid');
    } else {
        $('#length').removeClass('invalid').addClass('valid');
    }
    // Capital
    if (pswd.match(/[A-Z]/)) {
        $('#capital').removeClass('invalid').addClass('valid');
    } else {
        $('#capital').removeClass('valid').addClass('invalid');

    }

    // number
    if (pswd.match(/\d/)) {
        $('#number').removeClass('invalid').addClass('valid');
    } else {
        $('#number').removeClass('valid').addClass('invalid');
    }

    // character
    if (pswd.match(/[$&+,:;=?@#|'<>.^*()%!-]/)) {
        $('#special').removeClass('invalid').addClass('valid');
    } else {
        $('#special').removeClass('valid').addClass('invalid');
    }
}

var ConfirmPassword = function () {
        var passwordChecker = $('.passwordChecker').val(),
        passwordCheckerConfirm = $('.passwordCheckerConfirm').val(),
            all_pass = true;

    if (passwordChecker == passwordCheckerConfirm && passwordChecker != ''){
        $('.skp-password-match').removeClass('invalid').addClass('valid');
        $('.btn-save-new-password').removeClass('disabled');
        all_pass = true;
    }
    else {
        $('.skp-password-match').removeClass('valid').addClass('invalid');
        $('.btn-save-new-password').addClass('disabled');
        all_pass = false;
    }


}
module.exports = {

    togglePassword: function () {
        $(document).on('click', ".toggle-password", function () {
            var parent =  $(this).parent(".form-password");
            $(this).toggleClass("icon-password-show icon-password-hide");
            if ( parent.find('input').attr('type')=='password') {
               parent.find('input').attr('type', 'text');
            } else {
                parent.find('input').attr('type', 'password');
            }
        });
    },
    passwordStrenghtChecker: function () {

       $(document).on('focus','.passwordChecker',
       function () {
            // (triggers whenever the password field is selected by the user)
            $('.pswd_info').fadeIn('low');
            $('.pswd_info').addClass('pswd-active');
        });
        $(document).on('blur','.passwordChecker',function () {
            // (triggers whenever the password field is unselected)
            $('.pswd_info').fadeOut('low');
            $('.pswd_info').removeClass('pswd-active');
        });
        $(document).on('keyup','.passwordChecker',ruleValidator);
        $(document).on('keyup','.passwordCheckerConfirm',ConfirmPassword);
    },
    submitPassword: function () {
        
        $('form.change-password-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var successTitle = $('.change-password-title').data('success-title'),
                successMsg = $('.change-password-body').data('success-msg');
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        $('.change-password-title').text(successTitle);
                        $('.change-password-body').empty()
                            .append('<div class="request-password-body"><p>' + successMsg + '</p></div>');
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },
    ModalPassword: function () {
        var modalPassword = $('.modal-password'),
            closeModal = modalPassword.find('.close');

        if (modalPassword.lenght > 0) return;

        closeModal.on('click', function () {
            modalPassword.removeClass('show');
        })
    }
};